(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disease', {
            parent: 'entity',
            url: '/disease?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.disease.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease/diseases.html',
                    controller: 'DiseaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disease-detail', {
            parent: 'entity',
            url: '/disease/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.disease.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disease/disease-detail.html',
                    controller: 'DiseaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disease');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Disease', function($stateParams, Disease) {
                    return Disease.get({id : $stateParams.id});
                }]
            }
        })
        .state('disease.new', {
            parent: 'disease',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease/disease-dialog.html',
                    controller: 'DiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disease', null, { reload: true });
                }, function() {
                    $state.go('disease');
                });
            }]
        })
        .state('disease.edit', {
            parent: 'disease',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease/disease-dialog.html',
                    controller: 'DiseaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disease', function(Disease) {
                            return Disease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disease.delete', {
            parent: 'disease',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disease/disease-delete-dialog.html',
                    controller: 'DiseaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Disease', function(Disease) {
                            return Disease.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('disease', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
